import React, { useEffect, useState,useRef } from 'react';
import AxiosInstance from '../AxiosInstance';
import { useNavigate } from "react-router-dom";
import { Button } from 'react-bootstrap';
import Layout from './Layout';
import { ArrowLeftCircle ,Download} from "react-bootstrap-icons";
import ToastNotification from '../ToastNotification';

const EmployeeRecord = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const toastRef = useRef(null);
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const res = await AxiosInstance.get('/admin/all-employees');
      setEmployees(res.data);
    } catch (error) {
      toastRef.current?.showToast('Error fetching employees', 'danger');
    }
  };

  const downloadAllPDF = async () => {
    try {
      const response = await AxiosInstance.get('/admin/employees/pdf', {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'all_employees.pdf');
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      toastRef.current?.showToast('Error downloading employee report', 'danger');
    }
  };

  return (
    <Layout heading="Employee Record">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
          <Button
            className="btn btn-secondary px-3 py-2"
            style={{ color: "white", minWidth: "auto" }}
            onClick={downloadAllPDF}
          >
            <Download className="me-2" />
            Report
          </Button>
        </div>
        <div className="container mt-5">
        {/* 📱 Mobile View: Scrollable */}
        <div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="table table-hover text-center align-middle table-striped">
            <thead className="table-primary">
              <tr>
                <th>#</th>
                <th className="text-start">Full Name</th>
                <th className="text-start">Email</th>
                <th className="text-start">Emp Code</th>
                <th className="text-start">Dept</th>
                <th className="text-start">Designation</th>
                <th className="text-start">Manager</th>
              </tr>
            </thead>
            <tbody>
              {employees.length > 0 ? (
                employees.map((emp, index) => {
                  const fullName = [emp.first_name, emp.middle_name, emp.last_name].filter(Boolean).join(' ');
                  return (
                    <tr key={emp.user_id}>
                      <td>{index + 1}</td>
                      <td className="text-start">{fullName.replace(/\b\w/g, (char) => char.toUpperCase())}</td>
                      <td className="text-start">{emp.email}</td>
                      <td className="text-start">{emp.employee_code}</td>
                      <td className="text-start">{emp.department_name}</td>
                      <td className="text-start">{emp.designation_name}</td>
                      <td className="text-start">{emp.manager_name}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-muted">No employees found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      {/* 💻 Desktop View: Full Table */}
      <div className="table-responsive d-none d-md-block">
        <table className="table table-hover text-center align-middle table-striped">
          <thead className="table-primary">
            <tr>
              <th>#</th>
              <th className="text-start">Full Name</th>
              <th className="text-start">Email</th>
              <th className="text-start">Emp Code</th>
              <th className="text-start">Dept</th>
              <th className="text-start">Designation</th>
              <th className="text-start">Manager</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((emp, index) => {
                const fullName = [emp.first_name, emp.middle_name, emp.last_name].filter(Boolean).join(' ');
                return (
                  <tr key={emp.user_id}>
                    <td>{index + 1}</td>
                    <td className="text-start">{fullName.replace(/\b\w/g, (char) => char.toUpperCase())}</td>
                    <td className="text-start">{emp.email}</td>
                    <td className="text-start">{emp.employee_code}</td>
                    <td className="text-start">{emp.department_name}</td>
                    <td className="text-start">{emp.designation_name}</td>
                    <td className="text-start">{emp.manager_name}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-muted">No employees found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ToastNotification ref={toastRef} />
      </div>
    </Layout>
  );
};

export default EmployeeRecord;
